/**
 * A history entry that kept the status is something that happened along the
 * way rather than a move -- an interview accepted, a request for another
 * time, a round moved. `event` names it (docs/api.md, "Timeline notes"), so
 * its title says so instead of repeating the status ("Interview" twice).
 */
export function isTimelineNote(entry) {
  return Boolean(entry.from_status) && entry.from_status === entry.to_status;
}

const EVENT_TITLES = {
  INTERVIEW_ACCEPTED: 'Interview accepted',
  INTERVIEW_DECLINED: 'Interview declined',
  RESCHEDULE_REQUESTED: 'Another time requested',
  RESCHEDULE_WITHDRAWN: 'Request for another time withdrawn',
  INTERVIEW_RESCHEDULED: 'Interview rescheduled',
};

export function historyTitle(entry, labelFor) {
  if (isTimelineNote(entry)) {
    if (EVENT_TITLES[entry.event]) return EVENT_TITLES[entry.event];
    // Notes from before `event` existed were all reschedules.
    return entry.to_status === 'INTERVIEW' ? 'Interview rescheduled' : 'Update';
  }
  return labelFor(entry.to_status);
}
